// extracted by mini-css-extract-plugin
module.exports = {"container":"YkIELe","desktop":"_3vqD0S","logo":"_2uUvtJ","horizontal":"Tf5IBJ","mobile":"HuaXB8"};